import { useState } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Shield, Check } from "lucide-react";
import AuthModal from "@/components/AuthModal";

interface UnlockStrategyModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const UnlockStrategyModal = ({ open, onOpenChange }: UnlockStrategyModalProps) => {
  const [showAuth, setShowAuth] = useState(false);

  const handleShowAuth = () => {
    // Store the current analysis message so it survives the signup/email-confirm flow
    const currentUrl = window.location.pathname + window.location.search;
    sessionStorage.setItem("greyrock_return_url", currentUrl);
    localStorage.setItem("greyrock_return_url", currentUrl);
    setShowAuth(true);
  };

  if (showAuth) {
    return (
      <AuthModal
        open={open}
        onOpenChange={(v) => {
          if (!v) setShowAuth(false);
          onOpenChange(v);
        }}
        defaultMode="signup"
      />
    );
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-charcoal-dark border-cyan/30 max-w-md p-0 gap-0 overflow-hidden">
        {/* Header accent */}
        <div className="h-1 w-full bg-gradient-to-r from-cyan to-cyan-glow" />

        <div className="px-6 pt-6 pb-2 flex flex-col items-center text-center">
          <div
            className="w-12 h-12 rounded-full flex items-center justify-center mb-4"
            style={{
              background: "hsl(var(--cyan) / 0.12)",
              border: "1px solid hsl(var(--cyan) / 0.3)",
            }}
          >
            <Shield className="w-6 h-6 text-cyan" />
          </div>

          <h2 className="text-xl font-bold text-foreground tracking-tight mb-2">
            Unlock the Neutralizer Strategy
          </h2>
          <p className="text-sm text-muted-foreground leading-relaxed max-w-xs">
            Get the exact Grey Rock response blueprint and tactical advice to de-escalate this specific manipulation pattern.
          </p>
        </div>

        {/* Value props */}
        <div className="px-6 py-4 space-y-2.5">
          {[
            "Step-by-step 'Grey Rock' scripts",
            "Pattern-specific de-escalation tactics",
            "Save your analysis history",
          ].map((item) => (
            <div key={item} className="flex items-center gap-2.5">
              <Check className="w-4 h-4 text-cyan shrink-0" />
              <span className="text-sm text-foreground/80">{item}</span>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="px-6 pb-6 pt-2">
          <button
            onClick={handleShowAuth}
            className="w-full h-11 rounded-xl font-bold text-sm text-primary-foreground bg-gradient-to-r from-cyan to-cyan-glow hover:opacity-90 transition-opacity flex items-center justify-center gap-2"
          >
            <Shield className="w-4 h-4" />
            Sign Up to Unlock
          </button>

        </div>
      </DialogContent>
    </Dialog>
  );
};

export default UnlockStrategyModal;
